








































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class DiscountIcon extends Vue {
  @Prop({ default: '26' }) readonly width?: string;
  @Prop({ default: '26' }) readonly height?: string;
  @Prop({ default: '#405F7A' }) readonly color?: string;
}
